/**
 * Shared Select Options
 *
 * Reusable `{ value, label }` option arrays for SelectField inputs that are
 * duplicated across multiple entity forms. Entity-specific option sets (e.g.
 * technology lifecycle stages, capability enums) stay local to their form.
 */

import { type SelectOption } from '../components/forms';

/** Data classification levels (DataDomain, DataObject). */
export const classificationOptions: SelectOption[] = [
  { value: 'public', label: 'Public' },
  { value: 'internal', label: 'Internal' },
  { value: 'confidential', label: 'Confidential' },
  { value: 'restricted', label: 'Restricted' },
];

/** Lifecycle status values (DataDomain, DataObject). */
export const lifecycleStatusOptions: SelectOption[] = [
  { value: 'planned', label: 'Planned' },
  { value: 'developing', label: 'Developing' },
  { value: 'active', label: 'Active' },
  { value: 'mature', label: 'Mature' },
  { value: 'deprecated', label: 'Deprecated' },
  { value: 'retired', label: 'Retired' },
];

/** Criticality levels (DataDomain). */
export const criticalityLevelOptions: SelectOption[] = [
  { value: 'critical', label: 'Critical' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];
